var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 717,
    height: 376,
    viewBox: "0 0 717 376",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M717 0H0V375.23H717V0Z",
    fill: "#B4E8F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.02 118.185C506.739 118.185 492.997 120.157 479.912 123.861C446.272 80.5427 393.752 52.6992 334.659 52.6992C247.066 52.6992 173.812 114.003 155.409 195.98C153.019 195.502 150.51 195.203 147.941 195.203C127.924 195.203 111.732 211.395 111.732 231.411C111.732 233.921 111.971 236.311 112.449 238.641C72.7154 248.858 43.3184 285.007 43.3184 327.967C43.3184 345.235 48.0984 361.427 56.3439 375.23H628.51C655.397 347.984 672.008 310.52 672.008 269.173C672.008 185.762 604.371 118.185 521.02 118.185Z",
    fill: "#5BC5DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.749 266.785C226.691 266.785 198.011 289.61 189.108 320.799H332.449C323.486 289.61 294.806 266.785 260.749 266.785Z",
    fill: "#39AECB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.251 266.785C422.193 266.785 393.513 289.61 384.61 320.799H527.951C518.988 289.61 490.308 266.785 456.251 266.785Z",
    fill: "#39AECB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M363.101 243.662C314.464 243.662 273.476 276.286 260.749 320.799H465.453C452.726 276.286 411.737 243.662 363.101 243.662Z",
    fill: "#39AECB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M525.441 342.188H191.558C185.404 342.188 180.385 337.169 180.385 331.015C180.385 324.861 185.404 319.842 191.558 319.842H525.381C531.536 319.842 536.555 324.861 536.555 331.015C536.614 337.229 531.595 342.188 525.441 342.188Z",
    fill: "#1698B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4015 64.7695C69.3695 64.7695 51.6835 78.8705 46.1865 98.11H134.676C129.12 78.8705 111.434 64.7695 90.4015 64.7695Z",
    fill: "#F1F9FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.097 64.7695C190.065 64.7695 172.379 78.8705 166.882 98.11H255.372C249.815 78.8705 232.069 64.7695 211.097 64.7695Z",
    fill: "#F1F9FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153.617 50.4893C123.622 50.4893 98.2882 70.625 90.4609 98.11H216.832C208.945 70.625 183.611 50.4893 153.617 50.4893Z",
    fill: "#F1F9FC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M532.91 178.893C518.271 178.893 505.903 188.692 502.079 202.135H563.741C559.917 188.751 547.549 178.893 532.91 178.893Z",
    fill: "#DBF0F7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M617.038 178.893C602.399 178.893 590.031 188.692 586.207 202.135H647.869C644.045 188.751 631.677 178.893 617.038 178.893Z",
    fill: "#DBF0F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M576.946 168.975C556.033 168.975 538.347 183.016 532.91 202.196H620.982C615.485 183.016 597.858 168.975 576.946 168.975Z",
    fill: "#DBF0F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.685 90.1016C94.0467 90.1016 81.6785 99.9006 77.8545 113.344H139.516C135.692 99.9006 123.324 90.1016 108.685 90.1016Z",
    fill: "#DBF0F7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M192.813 90.1016C178.175 90.1016 165.806 99.9006 161.982 113.344H223.644C219.82 99.9006 207.452 90.1016 192.813 90.1016Z",
    fill: "#DBF0F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M152.721 80.124C131.809 80.124 114.123 94.1653 108.686 113.345H196.757C191.32 94.1653 173.634 80.124 152.721 80.124Z",
    fill: "#DBF0F7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M573.48 196.46C565.773 196.46 559.32 201.598 557.288 208.649H589.673C587.641 201.598 581.128 196.46 573.48 196.46Z",
    fill: "#F1F9FC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617.636 196.46C609.928 196.46 603.475 201.598 601.443 208.649H633.828C631.796 201.598 625.343 196.46 617.636 196.46Z",
    fill: "#F1F9FC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M596.604 191.201C585.61 191.201 576.348 198.55 573.48 208.648H619.727C616.859 198.55 607.598 191.201 596.604 191.201Z",
    fill: "#F1F9FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M583.519 325.101C568.82 325.101 556.392 334.959 552.568 348.463H614.469C610.586 334.959 598.217 325.101 583.519 325.101Z",
    fill: "#066F90"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M543.247 315.122C522.215 315.122 504.529 329.223 499.032 348.463H587.462C581.965 329.223 564.279 315.122 543.247 315.122Z",
    fill: "#066F90"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.917 257.044C154.742 257.044 155.41 257.713 155.41 258.538V322.112C155.41 322.937 154.742 323.605 153.917 323.605C153.092 323.605 152.423 322.937 152.423 322.112V258.538C152.423 257.713 153.092 257.044 153.917 257.044Z",
    fill: "#066F90"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.486 272.058C166.071 272.639 166.074 273.585 165.492 274.17L154.976 284.746C154.394 285.331 153.448 285.333 152.863 284.752C152.278 284.17 152.276 283.224 152.857 282.639L163.373 272.064C163.955 271.479 164.901 271.476 165.486 272.058Z",
    fill: "#066F90"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.985 282.875C142.569 282.292 143.514 282.292 144.098 282.875L154.972 293.749C155.556 294.333 155.556 295.279 154.972 295.862C154.389 296.445 153.443 296.445 152.86 295.862L141.985 284.987C141.402 284.404 141.402 283.458 141.985 282.875Z",
    fill: "#066F90"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.917 220.356V271.144C153.917 271.144 164.493 259.791 164.493 245.75C164.552 231.769 153.917 220.356 153.917 220.356Z",
    fill: "#FD9CAE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M143.341 245.751C143.341 259.792 153.917 271.145 153.917 271.145V220.357C153.917 220.357 143.341 231.77 143.341 245.751Z",
    fill: "#FEBBC4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.244 247.425L160.728 277.001C160.728 277.001 173.514 276.523 181.64 268.397C189.766 260.211 190.244 247.425 190.244 247.425Z",
    fill: "#FD9CAE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M169.332 256.029C161.146 264.215 160.728 276.941 160.728 276.941L190.244 247.425C190.244 247.425 177.458 247.903 169.332 256.029Z",
    fill: "#FEBBC4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M145.312 286.201L111.255 252.144C111.255 252.144 111.793 266.902 121.173 276.283C130.554 285.663 145.312 286.201 145.312 286.201Z",
    fill: "#FD9CAE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.394 262.062C126.013 252.681 111.255 252.144 111.255 252.144L145.312 286.201C145.312 286.201 144.775 271.503 135.394 262.062Z",
    fill: "#FEBBC4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.231 297.692C160.814 298.276 160.814 299.222 160.231 299.805L154.973 305.063C154.389 305.646 153.444 305.646 152.86 305.063C152.277 304.48 152.277 303.534 152.86 302.95L158.118 297.692C158.702 297.109 159.647 297.109 160.231 297.692Z",
    fill: "#066F90"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.749 314.523C138.739 314.523 128.641 322.59 125.475 333.584H175.963C172.856 322.53 162.759 314.523 150.749 314.523Z",
    fill: "#0383A4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M219.64 314.523C207.631 314.523 197.533 322.59 194.366 333.584H244.855C241.748 322.53 231.65 314.523 219.64 314.523Z",
    fill: "#0383A4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M186.838 306.338C169.69 306.338 155.23 317.81 150.749 333.524H222.867C218.386 317.87 203.927 306.338 186.838 306.338Z",
    fill: "#0383A4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M331.015 290.353L329.342 311.982H386.224L384.551 290.353H331.015Z",
    fill: "#EBECEC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M383.654 278.462H331.911L331.015 290.352H384.551L383.654 278.462Z",
    fill: "#CACDCD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M400.504 319.391H315.062V314.97C315.062 312.281 317.272 310.07 319.961 310.07H395.664C398.353 310.07 400.564 312.281 400.564 314.97V319.391H400.504Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M483.497 100.348H232.069C227.827 100.348 224.421 103.753 224.421 107.996V258.984H382.639H491.205V150.418V108.055C491.205 103.753 487.739 100.348 483.497 100.348Z",
    fill: "#00365D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M382.579 258.984H224.361V277.208C224.361 281.45 227.767 284.856 232.009 284.856H356.708H483.497C487.739 284.856 491.145 281.45 491.145 277.208V258.984H382.579Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M356.947 109.668H327.012H233.742V202.938V248.348H356.947H480.151V109.668H356.947Z",
    fill: "#F1F9FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 122,
    width: 28,
    height: 8,
    rx: 2,
    fill: "#1698B8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 122,
    width: 28,
    height: 8,
    rx: 2,
    fill: "#1698B8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 122,
    width: 38,
    height: 8,
    rx: 4,
    fill: "#055C7F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 145,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 161,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 177,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 193,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 209,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 225,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 323,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 441,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 241,
    width: 27,
    height: 4,
    rx: 2,
    fill: "#055C7F"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 139,
    x2: 468,
    y2: 139,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 155,
    x2: 468,
    y2: 155,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 171,
    x2: 468,
    y2: 171,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 187,
    x2: 468,
    y2: 187,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 203,
    x2: 468,
    y2: 203,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 219,
    x2: 468,
    y2: 219,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 245,
    y1: 235,
    x2: 468,
    y2: 235,
    stroke: "#84DAED",
    strokeWidth: 2
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M508.577 326.464C509.294 326.464 509.892 325.867 509.892 325.15V188.621C509.892 187.904 509.294 187.307 508.577 187.307C507.86 187.307 507.263 187.904 507.263 188.621V325.15C507.263 325.867 507.86 326.464 508.577 326.464Z",
    fill: "#055C7F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M487.664 326.464C488.381 326.464 488.979 325.867 488.979 325.15V188.621C488.979 187.904 488.381 187.307 487.664 187.307C486.947 187.307 486.35 187.904 486.35 188.621V325.15C486.409 325.867 486.947 326.464 487.664 326.464Z",
    fill: "#055C7F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 204.335H508.577C509.353 204.335 510.011 203.678 510.011 202.901C510.011 202.124 509.353 201.467 508.577 201.467H488.859C488.082 201.467 487.425 202.124 487.425 202.901C487.425 203.678 488.082 204.335 488.859 204.335Z",
    fill: "#055C7F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 218.018H508.577C509.353 218.018 510.011 217.361 510.011 216.584C510.011 215.808 509.353 215.15 508.577 215.15H488.859C488.082 215.15 487.425 215.808 487.425 216.584C487.425 217.361 488.082 218.018 488.859 218.018Z",
    fill: "#055C7F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 231.701H508.577C509.353 231.701 510.011 231.044 510.011 230.267C510.011 229.49 509.353 228.833 508.577 228.833H488.859C488.082 228.833 487.425 229.49 487.425 230.267C487.425 231.044 488.082 231.701 488.859 231.701Z",
    fill: "#055C7F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 245.384H508.577C509.353 245.384 510.011 244.726 510.011 243.95C510.011 243.173 509.353 242.516 508.577 242.516H488.859C488.082 242.516 487.425 243.173 487.425 243.95C487.425 244.786 488.082 245.384 488.859 245.384Z",
    fill: "#055C7F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 259.067H508.577C509.353 259.067 510.011 258.41 510.011 257.633C510.011 256.856 509.353 256.199 508.577 256.199H488.859C488.082 256.199 487.425 256.856 487.425 257.633C487.425 258.47 488.082 259.067 488.859 259.067Z",
    fill: "#055C7F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 272.749H508.577C509.353 272.749 510.011 272.092 510.011 271.315C510.011 270.538 509.353 269.881 508.577 269.881H488.859C488.082 269.881 487.425 270.538 487.425 271.315C487.425 272.151 488.082 272.749 488.859 272.749Z",
    fill: "#055C7F"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 286.431H508.577C509.353 286.431 510.011 285.774 510.011 284.997C510.011 284.221 509.353 283.563 508.577 283.563H488.859C488.082 283.563 487.425 284.221 487.425 284.997C487.425 285.774 488.082 286.431 488.859 286.431Z",
    fill: "#055C7F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 300.115H508.577C509.353 300.115 510.011 299.458 510.011 298.681C510.011 297.904 509.353 297.247 508.577 297.247H488.859C488.082 297.247 487.425 297.904 487.425 298.681C487.425 299.518 488.082 300.115 488.859 300.115Z",
    fill: "#055C7F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M488.859 313.857H508.577C509.353 313.857 510.011 313.2 510.011 312.423C510.011 311.646 509.353 310.989 508.577 310.989H488.859C488.082 310.989 487.425 311.646 487.425 312.423C487.425 313.2 488.082 313.857 488.859 313.857Z",
    fill: "#055C7F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M554.84 182.506C554.84 182.451 554.785 182.342 554.785 182.287C554.566 181.63 553.854 181.302 553.198 181.521L544.768 184.586C544.111 184.805 543.782 185.517 544.001 186.174C544.22 186.83 544.932 187.159 545.589 186.94L554.019 183.875C554.566 183.601 554.894 183.053 554.84 182.506Z",
    fill: "#89512A"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M552.101 181.629C552.101 181.629 554.346 179.22 554.838 179.822C555.331 180.424 561.736 189.511 561.298 189.84C559.929 190.989 553.634 184.311 553.251 183.49C552.922 182.614 551.773 181.957 552.101 181.629Z",
    fill: "#F87895"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M467.09 118.46C467.09 118.46 461.835 114.738 460.303 115.23C458.77 115.668 463.368 119.774 467.2 120.048L467.09 118.46Z",
    fill: "#89512A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M465.831 117.419C465.448 118.35 465.01 119.28 464.682 120.211C479.735 126.287 487.618 127.929 502.945 122.291C505.299 121.415 505.244 120.484 504.204 118.678C504.478 118.404 504.478 118.404 504.204 118.678C503.164 116.926 502.507 116.981 500.263 117.857C485.373 123.605 480.94 121.36 465.831 117.419Z",
    fill: "#EC577F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M498.73 227.282C498.839 227.282 498.894 227.282 499.003 227.282C499.66 227.118 500.098 226.461 499.989 225.804L498.182 217.046C498.018 216.389 497.361 215.951 496.704 216.061C496.047 216.225 495.609 216.882 495.719 217.539L497.525 226.297C497.635 226.899 498.127 227.282 498.73 227.282Z",
    fill: "#89512A"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M495.994 222.193C497.308 222.138 498.621 222.028 499.935 221.809C495.994 200.734 492.983 172.434 503.548 152.727C500.318 151.14 497.143 149.607 493.914 148.074C486.195 165.263 492.764 204.074 495.994 222.193Z",
    fill: "#066F90"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M550.679 186.008C550.241 184.749 549.748 183.49 549.201 182.285C519.695 193.179 505.901 186.61 505.135 152.89C501.522 152.726 497.854 152.671 494.241 152.616C499.551 189.511 517.232 197.941 550.679 186.008Z",
    fill: "#066F90"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M496.54 102.639C497.744 101.927 499.66 101.927 500.646 102.968C501.631 103.953 501.248 105.705 500.263 106.69C499.277 107.675 496.267 107.73 495.281 106.745C494.296 105.759 494.953 103.57 496.54 102.639Z",
    fill: "#210E00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M503.437 102.091C504.751 99.5732 508.2 97.712 511.046 98.3141C513.948 98.971 515.261 102.31 514.659 105.047C514.057 107.784 509.952 111.069 505.572 110.412C502.671 110.029 501.795 105.266 503.437 102.091Z",
    fill: "#210E00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M501.084 100.942C502.069 99.0811 504.478 97.6031 506.558 98.0957C508.638 98.5337 509.514 101.052 509.076 103.077C508.638 105.157 504.861 107.511 502.781 107.018C500.756 106.58 499.88 103.351 501.084 100.942Z",
    fill: "#210E00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M504.807 108.825C504.807 112.602 502.179 115.667 499.88 115.667C497.581 115.667 496.486 112.602 496.486 108.825C496.486 105.048 498.347 103.132 500.647 103.132C502.946 103.132 504.807 105.048 504.807 108.825Z",
    fill: "#89512A"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M506.503 110.084C506.503 110.96 505.627 112.055 505.025 112.055C504.368 112.055 504.259 111.343 504.259 110.467C504.259 109.592 504.751 108.771 505.408 108.771C505.956 108.825 506.503 109.208 506.503 110.084Z",
    fill: "#89512A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M505.354 106.416C505.354 106.416 504.532 104.008 502.671 103.132C500.81 102.256 497.142 102.42 496.376 105.76C496.376 105.76 496.048 108.168 499.004 108.332C501.96 108.497 501.303 106.964 502.89 108.332C504.478 109.701 505.627 108.497 505.901 108.825L505.354 106.416Z",
    fill: "#210E00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M491.56 156.669C493.914 156.723 496.925 156.231 499.771 154.807C501.961 153.713 504.479 153.329 506.614 153.22C507.161 145.666 508.365 125.795 507.216 122.127C505.738 117.584 503.11 115.668 503.11 115.668C503.11 115.668 501.413 117.146 500.209 117.036C498.95 116.927 497.527 121.197 495.775 123.934C494.024 126.671 492.655 127.547 494.078 131.762C494.68 133.568 491.232 154.041 491.56 156.669Z",
    fill: "#F87895"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M504.642 110.85L500.701 110.467C500.646 111.014 500.208 116.16 500.427 118.076C500.591 118.678 501.577 118.952 502.617 118.678C503.602 118.459 504.259 117.857 504.314 117.309C504.149 116.16 504.423 112.711 504.642 110.85Z",
    fill: "#89512A"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M500.263 225.642C500.263 225.642 501.03 228.817 500.263 228.926C499.497 229.036 488.385 229.364 488.33 228.817C488.111 227.065 497.198 225.423 498.074 225.642C498.95 225.806 500.154 225.149 500.263 225.642Z",
    fill: "#F87895"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M477.163 134.114C477.163 134.114 471.963 129.844 470.266 130.227C468.623 130.556 473.112 135.209 477.163 135.811V134.114Z",
    fill: "#89512A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M476.616 133.511C476.178 134.442 475.74 135.427 475.302 136.248C491.56 143.748 503.493 145.28 507.544 125.355C508.146 122.289 506.832 122.837 505.573 121.852C503.384 122.235 502.836 121.742 502.398 124.589C499.771 143.255 490.684 137.507 476.616 133.511Z",
    fill: "#EC577F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide4);
export default __webpack_public_path__ + "static/media/slide4.21eeeef542689d73d76c5aa534c4ea2e.svg";
export { ForwardRef as ReactComponent };